import React, { Suspense, lazy, useState } from "react";
import { Container, Col, Row } from "reactstrap";
import * as Section from "@repoflow/components/section";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "./filter";

// recharts and its d3 tree are ~100KB gzipped and reachable from exactly two
// screens. Lazily loaded so the points list — the app's landing page — never
// pays for them.
const PointCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// A point's captures as numbers over a window: the KPI cards and the charts,
// under one range picker.
//
// EVERYTHING ON THIS SCREEN ANSWERS TO THE FILTER, which is why the filter is
// the first thing on it. A measure is summed as written, and every service on
// this platform that removes something writes a negative measure to record it,
// so nothing here is a holding — it is all a net change over the selected range.
//
// THREE THINGS LEFT THIS SCREEN ON 2026-08-13, the day after they arrived on it:
//
//   The usage table — one row per limit value, absolute, aggregated over each
//   limit's own period and deliberately outside the range control. It is scoped
//   by whatever dimensions its limit names, so on a point dimensioned by `orgId`
//   it is a row per organization and grows with the platform. The api read is
//   untouched; it has no reader in this app now.
//
//   The by-dimension breakdown and its picker, for the same reason a rank lower:
//   one row per value of a dimension the reader chose, and the values behind
//   `orgId` are every tenant there is. The chart folded to eight bars and an
//   `other`, so what it drew was the busiest organizations by name; the query
//   behind it grew with the platform. What is left groups by event type, whose
//   values are a closed set this service writes.
//
//   The capture list — the row-level explorer, one row per capture. Rows are not
//   what this screen is for, and the two tables the "Show as table" toggle opens
//   carry the same window as text for anyone who cannot read a tooltip.
export const Content = ({ match: { params } }) => {
  // The point is already in section context — Section.Query in
  // routes/points/point/index.js put it there — so the dimension inputs and the
  // measure charts both come from the point's own row without a second fetch.
  const { values } = Section.useSectionContext();

  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      {/* One filter row above everything it scopes. Every chart below re-renders
          against this slice and none of them has a filter of its own. */}
      <Row>
        <Col>
          <Filter dimensions={values?.dimensions || []} onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <PointCharts
              pointId={params.pointId}
              measures={values?.measures || []}
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
